import React, {Fragment, useEffect, useState} from "react";
import {withRouter} from "react-router-dom";
import {spinnerOff, spinnerOn} from "../../components/Spinner";
import {post} from "../../api";
import ViewType from "../../components/ViewType";
import ProjectsGrid from "../../components/ProjectsGrid";
import ProjectsList from "../../components/ProjectsList";

export default withRouter(function Active(props) {
    const {cardview, onViewTypeChange, history, context, projectList} = props;
    const [projects, setProjects] = useState([]);
    const [isLoading, setIsLoading] = useState(false);     

    useEffect(() => {
        // Function to make network call to retrieve projects array for tab.
        async function getProjects() {
            if (projects && projects.length < 1) {
                spinnerOn();
                setIsLoading(true);
                let project = {};
                project.projectStatus = "N";
                const result = await post(`projects`, "", project);
                setProjects(result.projects);
                spinnerOff();
                setIsLoading(false);
            }
        }

        getProjects();
    }, []);

    function goToProject(project) {
        history.push(`/checklist/${project.id}`);
        context.setProjectTab('checklistna');
    }

    return (
        <Fragment>
            <div style={{
                display: "flex",
                flexDirection: "row",
                flewGrow: 1,
                justifyContent: 'center',
                paddingRight: '16px',
                paddingBottom: '16px'
            }}>
                <div style={{flexGrow: 1}}/>
                <ViewType onViewTypeChange={onViewTypeChange} tabView={'checklistNA'}/>
            </div>
            {cardview === "cardview" ?
                <ProjectsGrid projects={projectList(projects)}
                              history={history}
                              context={context}
                              onButtonClick={goToProject}
                              isLoading={isLoading}
                              {...props} /> :
                <ProjectsList projects={projectList(projects)}
                              onButtonClick={goToProject}
                              {...props}
                              />
            }
        </Fragment>
    );
})
